<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'description',
      content: 'Miss W - Your Vote Will Determine Who Will WIN 1499 BTC',
    },
  ],
})
</script>

<template>
  <div w-full overflow-x-hidden lt-lg:hidden>
    <Btc1000Section1 />
    <Btc1000Section2 />

    <IntroductionSection12 />

    <Btc1000Section3 />
  </div>

  <div w-full overflow-x-hidden lg:hidden class="mobile">
    <Btc1000MSection1 />

    <div class="bg">
      <Btc1000MSection2 />

      <IntroductionSection12 />

      <Btc1000Section3 />
    </div>
  </div>
</template>

<style scoped>
.mobile .bg {
  background: linear-gradient(
    180deg,
    #000 0%,
    #80000e 17.21%,
    #180003 36.27%,
    #000 60.15%,
    #80000e 100%
  );
}
</style>
